(function(){

  function split(arr, n) {
    var res = [];
    while (arr.length) {
      res.push(arr.splice(0, n));
    }
    return res;
  }

  function stagger(res, n){
    var target;

    // prevent single element arrays
    if ( res.length > 1 && (res[res.length-1].length < n) ) {
      while( res[res.length-1].length ) {
        target = res.length > 2 ? 1 : 0;
        res[target].push( res[res.length-1].pop() );
      }
      res.pop();
    }

    if ( res.length > 1 ) {
      res[res.length - 1].push( res[0].pop() );
    } else if (res && res.length && (res[0].length === 1)){
      Em.set( res[0][0], 'single', true );
    }

    return res;
  }

  var sizeTimer;

  Pegasus.ImageGalleryController = Em.ArrayController.extend({
    needs: ['savedImages', 'pexelsImages', 'upload', 'iconsImages', 'patternImages'],
    page: null,
    isFinishedPaging: false,
    query: function(_,value){
      if ( typeof(value) !== 'undefined') {
        return value;
      }
      return '';
    }.property(),
    lastPage: null,

    doSearch: function(){
      this.reset();
      Em.run.scheduleOnce('afterRender', this, 'getNextPage');
    },

    reset: function(){
      //this.set('breakValue', null);
      this.set('pages', []);
      this.set('page', null);
      this.set('lastPage', null);
      this.set('isFinishedPaging', false);
    },

    zeroPage: function(){
      return {
        page: 0,
        dated: Em.I18n.t('g.this_email')
      };
    }.property(),

    zeroPagePhotos: [],

    deleteThis: function(content){
      if ( this.get('zeroPagePhotos').indexOf( content ) >= 0 ) {
        this.get('zeroPagePhotos').removeObject(content);
        return;
      }

      this.get('pages').forEach(function(page){
        if ( page.photos.flatten().indexOf( content ) >= 0 ) {
          page.photos.forEach(function(arr){
            if ( arr.indexOf( content ) >= 0 ) {
              arr.removeObject(content);
            }
          });
        }
      });

      this.get('controllers.savedImages').send('deleteUserImageRequested', content);
    },

    useThis: function(view, size){
      this.get('controllers.' + this.get('loadingControllerName') ).useThis( view, size );
      this.close();
    },

    close: function(){
      this.set('controllers.upload.shouldShowImageGallery', false);
    },

    cancel: function(){
      this.set('controllers.upload.shouldShowImageReplacer', true);
      this.close();
    },

    didRetrieveImages: function(data, controller){
      if ( !data.next_page ) {
        this.set('isFinishedPaging', true);
      }

      this.set('lastPage', data.page);
      var photos = data.photos.reduce(function(accum, p){
        accum.push({
          thumbnail: p.preview,
          src: p.preview,
          data: p,
          aspectRatio: p.width / p.height
        })
        return accum;
      }, []);

      var additions = split( photos, controller.get('breakValue'));
      if ( controller.get('staggerResults') ) {
        additions = stagger( additions, controller.get('breakValue') );
      }

      this.get('pages').addObject( $.extend({}, data, {
        photos: additions
      }));
      //this.get('cache').addObjects(additions);
      //this.set('cache', this.get('arrangedObjects'));

      $(window).trigger('resize');
    },

    loadingControllerName: null,

    isPexelsList: Em.computed.equal( 'loadingControllerName', 'pexelsImages'),
    isIconsList: Em.computed.equal( 'loadingControllerName', 'iconsImages'),
    isSavedList: Em.computed.equal( 'loadingControllerName', 'savedImages'),
    isPatternsList: Em.computed.equal( 'loadingControllerName', 'patternImages'),

    shouldShowSearchBar: function(){
      return ! this.get('isSavedList') && ! this.get('isPatternsList');
    }.property('loadingControllerName'),

    selectedIconColor: '#000000',

    didChangeSelectedIconColor: function(){
      var iconColor = this.get('selectedIconColor');


      // remove g element that have a single rect
      // this usually happens when the artist explicitly sets
      // a backdrop.  We don't want backdrops
      //$('.vr-image-gallery').
        //find('g').each(function(index, item){
        //var el = $(item);
        //if ( el.find('rect').length && !el.find('rect').siblings().length ) {
          //el.css('display', 'none');
        //}
      //});

      // Normalize coloring
      $('.vr-image-gallery').
        find('svg, path, line, circle, rect, polyline, polygon, ellipse').each( function(index, item){
          var el = $(item);
          if ( el.attr('fill') && (el.attr('fill') !== 'none')  ) {
            el.attr('fill', iconColor);
          } else if( el.attr('fill') === "" ) {
            el.attr('fill', iconColor);
          }
          if ( el.css('fill') && (el.css('fill') !== 'none')  ) {
            el.css('fill', iconColor);
          }

          var el = $(item);
          if ( el.attr('stroke') && (el.attr('stroke') !== 'none')  ) {
            el.attr('stroke', iconColor);
          }
          if ( el.css('stroke') && (el.css('stroke') !== 'none')  ) {
            el.css('stroke', iconColor);
          }
        });
    }.observes('selectedIconColor'),

    getNextPage: function(){
      if ( this.get('isFinishedPaging') ) { return; }

      if ( this.get('page') !== this.get('lastPage') ){
        return;
      }

      if ( !this.get('page') ) {
        this.set('page', 1);
      } else {
        this.incrementProperty('page');
      }

      this.get('controllers.' + this.get('loadingControllerName')).request(
        this.get('query') ? this.get('query') : null,
        this.get('page'),
        17
      );
    },

    content: [],

    breakValue: 3,

    cache: [],

    pages: [],

    //breakValueChanged: function(){
      //var members = this.get('cache').toArray();
      //Em.beginPropertyChanges();
      //this.get('cache').clear();
      //this.set('cache', split( members.flatten(), this.get('breakValue')));
      //Em.endPropertyChanges();
    //}.observes('breakValue'),

    zeroPagePhotosChanged: function(){
      var photos = this.get('zeroPagePhotos').flatten();
      photos.forEach(function(p){
        if ( p.single ) {
          Em.set(p, 'single', false);
        }
      });

      var controller = this.get('controllers.' + this.get('loadingControllerName') );
      var results = split( photos, controller.get('breakValue'));

      if ( controller.get('staggerResults') ) {
        results = stagger( results, controller.get('breakValue') );
      }

      this.set('zeroPage.photos', results);;
    }.observes('zeroPagePhotos.length'),

    loadingControllerObserver: function(){
      this.getNextPage();
    }.observes('loadingControllerName'),

    populateThisEmailsImages: function(){
      //var controller = this;

      //var addImagesFromAttr = function(attr){
        //$('[' + attr + ']').each(function(_, i){
          //var workingImage = $('<img>');
          //var item = $(i);
          //var workingSrc = item.attr(attr);

          //if ( !workingSrc ) { return; }
          //workingImage.attr('src', workingSrc);
          //workingImage.imagesLoaded().always(function(img){
            //if ( controller.get('zeroPagePhotos').filterProperty('src', img.images[0].img.src).length ) { return; }
            //controller.get('zeroPagePhotos').addObject({
              //thumbnail: img.images[0].img.src,
              //src: img.images[0].img.src,
              //aspectRatio: img.images[0].img.naturalWidth/img.images[0].img.naturalHeight
            //});
          //});
        //});
      //};

      //addImagesFromAttr( 'data-src' );
      //addImagesFromAttr( 'data-background-image' );

      this.send('requestTemplateImages');
      this.get('pages').addObject(this.get('zeroPage'));
    },

    init: function(){
      this._super();
      $(window).on('resize.imageGallery', function(){
        Em.run.cancel(sizeTimer);
        sizeTimer = Em.run.later(this, function(){
          var width = $(window).width();

          //if ( width >= 1400 ) {
            //if ( this.get('breakValue') !== 5 ) {
              //Em.run.scheduleOnce('afterRender', this, 'set', 'breakValue', 5);
            //}
          //} else if ( width >= 1100 ) {
            //if ( this.get('breakValue') !== 4 ) {
              //Em.run.scheduleOnce('afterRender', this, 'set', 'breakValue', 4);
            //}
          //} else if ( width >= 800 ) {
            //if ( this.get('breakValue') !== 3 ) {
              //Em.run.scheduleOnce('afterRender', this, 'set', 'breakValue', 3);
            //}
          //} else if ( width >= 500 ) {
            //if ( this.get('breakValue') !== 2 ) {
              //Em.run.scheduleOnce('afterRender', this, 'set', 'breakValue', 2);
            //}
          //} else {
            //if ( this.get('breakValue') !== 1 ) {
              //Em.run.scheduleOnce('afterRender', this, 'set', 'breakValue', 1);
            //}
          //}

          $(window).trigger('gallery-resized');
        }, 250);
      }.bind(this));
    }
  });
})();
